import { ChannelType } from '~/constants';
import i18n from '~/i18n';

import environment from './providers/environment';

class DoorayAppStore {
  id = 'doorayApp';
  description = '';
  iconAttachId = '';
  name = environment.serviceTitle;

  getAllCommands = () => {
    return [
      {
        id: 'invite',
        description: i18n.t('systemCommand.invite.description', '대화방에 없는 사람을 초대할 수 있습니다.'),
        name: '/invite',
        parameterHint: i18n.t('systemCommand.invite.parameter', '@멤버...'),
        errorMessage: i18n.t('systemCommand.invite.errorMessage', '초대에 실패했습니다. 입력한 멤버를 확인해 주세요.'),
        channelTypes: [ChannelType.Direct, ChannelType.Private],
      },
      {
        id: 'leave',
        description: i18n.t('systemCommand.leave.description', '대화방에서 나갑니다.'),
        name: '/leave',
        parameterHint: '',
        channelTypes: [ChannelType.Direct, ChannelType.Private],
      },
      {
        id: 'mute',
        description: i18n.t('systemCommand.mute.description', '대화방의 알림을 끕니다.'),
        name: '/mute',
        parameterHint: '',
        channelTypes: [ChannelType.Direct, ChannelType.Private, ChannelType.Bot],
      },
      {
        id: 'unmute',
        description: i18n.t('systemCommand.unmute.description', '대화방의 알림을 켭니다.'),
        name: '/unmute',
        parameterHint: '',
        channelTypes: [ChannelType.Direct, ChannelType.Private, ChannelType.Bot],
      },
      {
        id: 'status',
        description: i18n.t('systemCommand.status.description', '상태를 변경할 수 있습니다.'),
        name: '/status',
        parameterHint: 'away or online or busy',
        errorMessage: i18n.t(
          'systemCommand.status.errorMessage',
          '아래의 형태로 입력하여 상태를 변경할 수 있습니다. <br/>/status away<br/>/status online<br/>/status busy'
        ),
        channelTypes: [ChannelType.ALL],
      },
      {
        id: 'goto',
        description: i18n.t('systemCommand.goto.description', '다른 대화방으로 이동할 수 있습니다.'),
        name: '/goto',
        parameterHint: i18n.t('systemCommand.goto.parameter', '#대화방 or @멤버'),
        errorMessage: i18n.t(
          'systemCommand.goto.errorMessage',
          '아래의 형태로 입력하여 대화방으로 이동할 수 있습니다.<br/>/goto #[대화방]<br/>/goto @[사람]'
        ),
        channelTypes: [ChannelType.ALL],
      },
      {
        id: 'search',
        description: i18n.t(
          'systemCommand.search.description',
          '이 대화방 또는 전체 대화방의 메시지를 검색할 수 있습니다.'
        ),
        name: '/search',
        parameterHint: 'query',
        errorMessage: i18n.t('systemCommand.search.errorMessage', '검색어를 포함하여 입력하세요.'),
        channelTypes: [ChannelType.ALL],
      },
      {
        id: 'topic',
        description: i18n.t('systemCommand.topic.description', '대화방의 주제를 바꿀 수 있습니다.'),
        name: '/topic',
        parameterHint: 'topic',
        errorMessage: i18n.t(
          'systemCommand.topic.errorMessage',
          '대화방 주제 변경에 실패했습니다. 아래에 맞도록 대화방 주제를 입력해 주세요.<br/>- 1자 이상 30자 이내'
        ),
        channelTypes: [ChannelType.Private],
      },
      {
        id: 'desc',
        description: i18n.t('systemCommand.desc.description', '대화방의 설명을 바꿀 수 있습니다.'),
        name: '/desc',
        parameterHint: 'description',
        errorMessage: i18n.t(
          'systemCommand.desc.errorMessage',
          '대화방 설명 변경에 실패했습니다. 아래와 맞도록 대화방 설명을 입력해 주세요.<br/>- 200자 이내'
        ),
        channelTypes: [ChannelType.Private],
      },
      {
        id: 'task',
        description: i18n.t('systemCommand.task.description', 'Dooray! 프로젝트로 새 업무 쓰기'),
        name: '/task',
        parameterHint: i18n.t('systemCommand.task.parameter', '@멤버 제목'),
        errorMessage: '',
        channelTypes: [ChannelType.ALL],
      },
      {
        id: 'mail',
        description: i18n.t('systemCommand.mail.description', 'Dooray! 메일로 새 메일 쓰기'),
        name: '/mail',
        parameterHint: i18n.t('systemCommand.mail.parameter', '@멤버 제목'),
        errorMessage: '',
        channelTypes: [ChannelType.ALL],
      },
      {
        id: 'event',
        description: i18n.t('systemCommand.event.description', 'Dooray! 캘린더로 새 일정 쓰기'),
        name: '/event',
        parameterHint: i18n.t('systemCommand.event.parameter', '@멤버 제목'),
        errorMessage: '',
        channelTypes: [ChannelType.ALL],
      },
      {
        id: 'form',
        description: i18n.t('systemCommand.form.description', 'Dooray! 폼으로 새 폼 쓰기'),
        name: '/form',
        parameterHint: '',
        errorMessage: '',
        channelTypes: [ChannelType.ALL],
      },
    ];
  };
}

export default DoorayAppStore;

export const doorayAppStore = new DoorayAppStore();
